import React, { Component } from "react";

import '../noticiasEventos.css';

import{FormattedDate} from "react-intl";
import{FormattedTime} from "react-intl";

import Modal from 'react-modal';

import ModalInscricao from "./ModalInscricao";

import PhotoGallery from "../../utils/PhotoGallery";


Modal.setAppElement(document.getElementById('root'));

const img = {
  width: "100%",
  marginBottom: "48px",
}

const texto = {
  fontSize: "16px",
  lineHeight: "40px",
  color: "#262626",
  marginBottom: "40px"
}

const date = {
  fontSize: "14px",
  color: "#262626",
  marginBottom: "48px"
}


class Evento extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
      newStartDate: new Date(),
      newEndDate: new Date(),
      newInsertionDate: new Date()
    };

    this.openModal = this.openModal.bind(this); 
    this.closeModal = this.closeModal.bind(this);
    this.isInscricaoAvailable = this.isInscricaoAvailable.bind(this);

  }

  openModal() {
    this.setState({modalIsOpen: true});
  }
 
  closeModal() {
    this.setState({modalIsOpen: false});
  }

  componentDidMount() {
  }

 
  componentWillReceiveProps(nextProps) {
    
    if(nextProps.noticia.startDate !== null){      
      this.setState({newStartDate: nextProps.noticia.startDate});
    } else{
      this.setState({newStartDate: ""});
    }

    if(nextProps.noticia.endDate !== null){  
      this.setState({newEndDate: nextProps.noticia.endDate});
    } else{
      this.setState({newEndDate: ""});
    }

    if(nextProps.noticia.startTime !== null){
      this.setState({newStartTime: nextProps.noticia.startTime});
    } else{
      this.setState({newStartTime: ""});
    }

    if(nextProps.noticia.endTime !== null){
      this.setState({newEndTime: nextProps.noticia.endTime});
    } else{
      this.setState({newEndTime: ""});
    }

    if(nextProps.noticia.insertionDate !== null){
      this.setState({newInsertionDate: nextProps.noticia.insertionDate});
    } else{
      this.setState({newInsertionDate: ""});
    }

    if(nextProps.noticia.permiteInscricao){
      const available = parseInt(nextProps.noticia.maxParticipants) - parseInt(nextProps.noticia.currentParticipants);
      this.setState({availableParticipants: available});
    }
    
  }

  isInscricaoAvailable = () => {
    
    if(this.props.noticia !== null && this.props.noticia.permiteInscricao) {

      let isInTime = Date.now() < Date.parse(this.props.noticia.startDate);

      if(isInTime){
        return true;
      } else {
        return false;
      }
    } else{
      return false;
    }

  }


  

  render() {

    return (
      <React.Fragment>

        {this.state.modalIsOpen ? 
          <ModalInscricao modalIsOpen={this.state.modalIsOpen} noticia={this.props.noticia} closeModal={this.closeModal} openModal={this.openModal}></ModalInscricao>
          :
          <React.Fragment>
            <div className="col-12 col-md-6 container-rich-text-description">
          <p style={texto} dangerouslySetInnerHTML={{ __html: this.props.noticia.description }}></p>
          
          <p style={date} className="date"><span style={{fontWeight: 'bold'}}>Data de inserção: &nbsp;</span>


          <FormattedDate
              value={this.state.newInsertionDate}
              year='numeric'
              month='long'
              day='2-digit'
              />
          </p>

          
        </div>
        {this.props.noticia && (
          <div className="offset-md-2 col-12 col-md-4">


              {this.isInscricaoAvailable() ? 

                (this.props.noticia.permiteInscricao && this.state.availableParticipants !== undefined && this.state.availableParticipants > 0) ? 
                  <button
                  onClick={this.openModal}
                  id="btn-inscrever"
                  type="button"
                  className="btn btn-success"
                  >Inscrever</button>

                  :

                  <button
                  id="btn-inscrever"
                  type="button"
                  className="btn btn-success"
                  disabled
                  >Esgotado</button>
                 
              :

              null
            
            }

              <img style={img} src={this.props.noticia.mainPhoto} alt="Imagem notícia" />
              
              
              <div  className="box-shadow event-details-info">
                <p>Início</p> 
                <span className="texto-detalhes">
                  <FormattedDate
                    value={this.state.newStartDate}
                    year='numeric'
                    month='long'
                    day='2-digit'
                  />
                  {
                  this.state.newStartTime !== undefined && this.state.newStartTime !== "" &&
                  <span>, &nbsp;</span>
                  }
                  
                  {
                  this.state.newStartTime !== undefined && this.state.newStartTime !== "" &&
                    <FormattedTime value={this.state.newStartTime} />
                  }
                  {
                  this.state.newStartTime !== undefined && this.state.newStartTime !== "" &&
                    <span>&nbsp; h</span>
                  }
                  
                </span>

                {
                  this.state.newEndDate !== undefined && this.state.newEndDate !== "" &&
                  <p className="spacing-details-event">Fim</p> 
                }
                {
                  this.state.newEndDate !== undefined && this.state.newEndDate !== "" &&

                  <span className="texto-detalhes">
                    <FormattedDate
                      value={this.state.newEndDate}
                      year='numeric'
                      month='long'
                      day='2-digit'
                    />
                    ,&nbsp;
                    {
                    this.state.newEndTime !== undefined && this.state.newEndTime !== "" &&
                      <FormattedTime value={this.state.newEndTime} />
                    }
                    {
                    this.state.newEndTime !== undefined && this.state.newEndTime !== "" &&
                      <span>&nbsp; h</span>
                    }
                    
                  </span>
                
                }
                
                <p className="spacing-details-event">Local</p>
                <span className="texto-detalhes">{this.props.noticia.location}</span>
              </div>

          </div>

          
        )}

        {this.props.noticia && this.props.noticia !== undefined && this.props.noticia.photos !== undefined && this.props.noticia.photos.length !== 0 && (
            <div className="container">
              <PhotoGallery photos={this.props.noticia.photos}></PhotoGallery>
            </div>
        )}
          </React.Fragment>
      } 
      </React.Fragment>
    );
  }

}

export default Evento;

